import axios from "axios";

const MarkupsService = {
    async fetchAll() {
        const url = '/marketplace/admin/api/markups-list';
        return axios.get(url, {});
    },
};

export default MarkupsService;